var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedinBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.3332 10.6665C23.4549 10.6665 25.4897 11.5094 26.99 13.0096C28.4903 14.5099 29.3332 16.5448 29.3332 18.6665V27.9998H23.9998V18.6665C23.9998 17.9593 23.7189 17.281 23.2188 16.7809C22.7187 16.2808 22.0404 15.9998 21.3332 15.9998C20.6259 15.9998 19.9477 16.2808 19.4476 16.7809C18.9475 17.281 18.6665 17.9593 18.6665 18.6665V27.9998H13.3332V18.6665C13.3332 16.5448 14.176 14.5099 15.6763 13.0096C17.1766 11.5094 19.2114 10.6665 21.3332 10.6665Z",
    stroke: "#1E1E1E",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.99984 11.9998H2.6665V27.9998H7.99984V11.9998Z",
    stroke: "#1E1E1E",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.33317 7.99984C6.80593 7.99984 7.99984 6.80593 7.99984 5.33317C7.99984 3.86041 6.80593 2.6665 5.33317 2.6665C3.86041 2.6665 2.6665 3.86041 2.6665 5.33317C2.6665 6.80593 3.86041 7.99984 5.33317 7.99984Z",
    stroke: "#1E1E1E",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinBlack);
export default __webpack_public_path__ + "static/media/linkedinBlack.f647333b741a1ae0e528af09c4acc6f5.svg";
export { ForwardRef as ReactComponent };